import { clarityEvent } from '@/lib/analytics/clarity';
import type { TContactFormData } from '@/lib/interfaces/forms/contactForm.types';

export async function submitContact(data: TContactFormData) {
  const url = process.env.NEXT_PUBLIC_FORM_SPREE_URL;
  if (!url) throw new Error('Missing NEXT_PUBLIC_FORM_SPREE_URL');
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: `${data.firstName} ${data.lastName}`.trim(),
      company: data.company,
      mobile: data.mobile,
      _replyto: data.email,
      roles: data.roles?.join(', '),
      _subject: 'New contact form submission',
      message: data.message,
    }),
  });
  if (!res.ok) throw new Error('Failed to send message');
  clarityEvent('contact_form_submitted');
  return true;
}
